import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';

const AddressModalViewHelper = {
    /**
     * Enums of the different address modal types that can be displayed
     *
     * @enum {string}
     */
    AddressModalTypes: {
        NEW: 'new',
        SAVED: 'saved',
    },

    /**
     * Helper function that assists in launching the address modal based on endpoint and type
     *
     * @param {Object} settings
     * @param {boolean=} settings.isChangeable Whether or not the modal can be changed from "saved" to "new"; defaults to false
     * @param {AddressModal} settings.modal The address modal to display
     * @param {string} settings.type The type of modal to initially display, e.g. new address or saved addresses
     * @param {string} settings.url The endpoint to hit to gather the saved addresses based on type
     */
    launchAddressModal({ isChangeable = false, modal, type, url }) {
        if (type === AddressModalViewHelper.AddressModalTypes.SAVED) {
            $.ajax({ url }).done((responseJson) => {
                modal.renderSaved(responseJson.data, isChangeable);
            });
        } else if (type === AddressModalViewHelper.AddressModalTypes.NEW) {
            modal.renderNew();
        } else {
            AlerterView.error();
        }
    },
};

export default AddressModalViewHelper;
